import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ChevronRight } from 'lucide-react';

export default function PageHero({ eyebrow, title, italicTitle, subtitle, breadcrumb }) {
  return (
    <section className="relative overflow-hidden pt-36 sm:pt-40 pb-16 sm:pb-20 lg:pb-24 bg-gradient-to-br from-[#0a1b35] via-[#0d2143] to-[#15315c]">
      <div className="absolute inset-0 bg-grid opacity-35" />
      <div className="absolute inset-0 noise-overlay" />
      <div className="absolute -top-32 -right-20 w-[500px] h-[500px] rounded-full" style={{ background: 'radial-gradient(circle, rgba(232,184,99,0.14) 0%, transparent 65%)' }} />
      <div className="absolute -bottom-40 -left-32 w-[600px] h-[600px] rounded-full" style={{ background: 'radial-gradient(circle, rgba(37,80,143,0.32) 0%, transparent 65%)' }} />

      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-6 lg:px-10">
        {breadcrumb && (
          <nav className="flex items-center gap-2 text-[12.5px] text-white/60 mb-5 sm:mb-6 flex-wrap" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-[#e8b863]">Home</Link>
            <ChevronRight className="w-3.5 h-3.5" />
            <span className="text-[#e8b863]">{breadcrumb}</span>
          </nav>
        )}
        {eyebrow && (
          <p className="text-[#e8b863] tracking-[0.28em] text-[11px] font-semibold uppercase mb-5">
            {eyebrow}
          </p>
        )}
        <h1 className="font-serif text-white font-medium text-[36px] sm:text-[48px] lg:text-[64px] leading-[1.05] tracking-tight max-w-4xl">
          {title}{' '}
          {italicTitle && <span className="italic gold-gradient">{italicTitle}</span>}
        </h1>
        {subtitle && (
          <p className="mt-6 sm:mt-7 text-white/78 text-[15.5px] sm:text-[17px] lg:text-[18px] leading-relaxed max-w-3xl">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}

export function CTABanner({ title = 'Ready to start a conversation?', subtitle = 'Share a few details and a senior consultant will be in touch within one business day.', button = 'Book a Consultation', to = '/contact' }) {
  return (
    <section className="relative py-20 sm:py-24 bg-[#0d2143] overflow-hidden">
      <div className="absolute inset-0 bg-grid opacity-25" />
      <div className="relative max-w-[1100px] mx-auto px-5 sm:px-6 lg:px-10 text-center">
        <h2 className="font-serif text-white font-medium text-[32px] sm:text-[40px] lg:text-[48px] leading-tight tracking-tight">
          {title}
        </h2>
        <p className="mt-5 text-white/75 text-[15.5px] sm:text-[17px] leading-relaxed max-w-2xl mx-auto">
          {subtitle}
        </p>
        <Link
          to={to}
          className="mt-9 inline-flex items-center gap-3 px-7 py-4 rounded-full bg-gradient-to-r from-[#d49d3f] to-[#b8842a] hover:from-[#e8b863] hover:to-[#d49d3f] text-[#0a1b35] font-semibold text-[14px] tracking-wide transition-all duration-300 shadow-xl shadow-[#d49d3f]/25 hover:-translate-y-0.5"
        >
          {button}
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </section>
  );
}
